import Page from '@/components/page'
import type { InferGetServerSidePropsType } from 'next'
import { getFooter, graphQLClient } from 'src/lib/graphql-contentful-api'
import type { Document } from '@contentful/rich-text-types'
import PageMetadata from '@/components/metadata'
import { ComponentRenderer } from 'src/lib/rich-text-render-helpers'
import { graphql } from '.gql/gql'
import type { ServerSideProps } from '@/pages/index'

export const WritingLegendsAccessibilityPage_Query = graphql(/* GraphQL */ `
  query WritingLegendsMarketingSiteAccessibilityPage(
    $id: String!
    $locale: String
  ) {
    writingLegendsMarketingSiteAccessibilityPage(id: $id, locale: $locale) {
      sys {
        id
      }
      accessibilityText {
        json
      }
      seoPageTitle
      seoPageDescription
      seoKeywords
    }
  }
`)

export const getServerSideProps = async ({ query, req }: ServerSideProps) => {
  const [{ data: footerData }, { data: accessibilityData }] = await Promise.all(
    [
      getFooter(query.locale),
      graphQLClient.query(WritingLegendsAccessibilityPage_Query, {
        id: '3YYA4XKHPRz7DlJW6BbffC',
        locale: query.locale,
      }),
    ],
  )

  if (
    !accessibilityData?.writingLegendsMarketingSiteAccessibilityPage ||
    !footerData?.composeComponentWlFooterBlock
  ) {
    return { notFound: true }
  }

  return {
    props: {
      footerProps: footerData.composeComponentWlFooterBlock,
      accessibilityProps:
        accessibilityData.writingLegendsMarketingSiteAccessibilityPage,
      country: query.country,
      domain: req.headers.host,
    },
  }
}

function Accessibility({
  footerProps,
  accessibilityProps,
  country,
  domain,
}: InferGetServerSidePropsType<typeof getServerSideProps>) {
  const { seoPageTitle, seoPageDescription, accessibilityText, seoKeywords } =
    accessibilityProps

  return (
    <>
      <PageMetadata
        description={seoPageDescription}
        keywords={seoKeywords}
        title={seoPageTitle}
      />
      <Page footerData={footerProps} country={country} domain={domain}>
        <ComponentRenderer
          classNames="content-container flex-col space-y-6 px-8 py-8 prose-h1:text-left"
          document={accessibilityText?.json as Document}
        />
      </Page>
    </>
  )
}

export default Accessibility
